import { Injectable, Inject } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { APIBase } from './api.base';
import { Router } from '@angular/router';
import { SessionStorageService } from '../services/session-storage.service';

@Injectable()
export class ControleChatsAPI extends APIBase {

	constructor(@Inject(AuthHttp) authHttp: AuthHttp, @Inject(Router) router: Router, @Inject(SessionStorageService) session: SessionStorageService) {
		super(authHttp, router, session);

		// Entidade principal
		this.__entity = 'controle_chats';
	}
	/**
	 * get by id
	 *
	 *
	 * @access public
	 * @author Nicolas Aoki
	 * @since  11/2019
	 * @param  object
	 * @return object Promise
	 */
	public getSimulacaoIncompletaById(id) {
		let dados = {
			Usuario:id
		};
        // return this._call(this.__entity + '/save', data);
		return this._call(this.__entity, dados , 'get'); 
	}
}


// WEBPACK FOOTER //
// ./src/api/controle_chats.api.ts